let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    /* Patch: isolate subscriber callback failures so one throw doesn't bail
       the dispatch chain. Discovered during D-Q5 #7 phase 3 drawer-fire
       investigation 2026-05-11. */
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (e) {
        console.error('pubsub subscriber threw for "' + eventName + '":', e);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
